export const LIGHT_COLOR = '#FFFFFF';
export const DARK_COLOR = '#404145';
